/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import MembershipRepository from '../../repositories/Admin/FastCash/MembershipRepository';
import { createRestSlice } from '../../utils/RestSlice';

const membershipsRestSlice = createRestSlice({
  resource: 'memberships',
  repository: MembershipRepository,
  slices: ['loadMemberships'],
});

const initialState = {
  ...membershipsRestSlice.initialState,
};

const membershipsSlice = createSlice({
  name: 'memberships',
  initialState,
  reducers: {
    ...membershipsRestSlice.reducers,
  },
});

export default membershipsSlice.reducer;

export const membershipsRestHooks = membershipsRestSlice.hooks(
  membershipsSlice,
  ['admin', 'MembershipsSlice']
);
